import React from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'
import { Leaderboard } from '@trivie/ui-mobile/components/leaderboard'

export const WeeklyLeaderboardTab = observer((props: any) => {
  const { load, selectedTag } = props
  const { rootCache, leaderboardStore } = useStores()

  const { loadingWeekly, weeklyUserLeaderboard, tagLeaderboard } = leaderboardStore

  const refresh = () => {
    rootCache.invalidateAction('getLeaderboards', leaderboardStore)
    rootCache.invalidateAction('getLeaderboardRank', leaderboardStore)
    load('weekly')
  }

  return (
    <Leaderboard
      refresh={refresh}
      data={
        selectedTag !== '' && selectedTag !== 'User'
          ? tagLeaderboard.filter((tag: any) => tag.rank != null)
          : weeklyUserLeaderboard
      }
      loading={loadingWeekly}
      selectedTag={selectedTag}
    />
  )
})
